import React from 'react';
import styled, { keyframes } from 'styled-components';

interface ContainerProps {
  width?: string;
  height?: string;
  $backgroundColor?: string;
}

const pulse = keyframes`
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.7;
  }
  100% {
    opacity: 1;
  }
`;

const Container = styled.span<ContainerProps>`
  width: ${(props) => `${props.width}px` || 'auto'};
  height: ${(props) => `${props.height}px` || 'auto'};
  display: block;
  background-color: ${(props) => props.$backgroundColor};
  overflow: hidden;
  position: relative;
  animation: ${pulse} 1.4s infinite linear;
  border-radius: 8px;
`;

interface SkeletonPulseProps {
  width?: string;
  height?: string;
  backgroundColor?: string;
}

const SkeletonPulse: React.FC<SkeletonPulseProps> = ({
  width,
  height,
  backgroundColor = '#4B5360'
}) => {
  return (
    <Container
      width={width}
      height={height}
      $backgroundColor={backgroundColor}
    />
  );
};

export default SkeletonPulse;
